import * as authActionTypes from "../Action/ActionTypes";
import {getPlanFlowProcess, getRabbitMqHealthSaga} from "./SuperAdminSaga"
import * as SAGA from "./SuperAdminSaga";

import { takeLatest, takeEvery } from "redux-saga/effects";

export function* watchSuperAdmin() {
  yield takeLatest(authActionTypes.ADD_ROLE, SAGA.addRoleSaga);
  yield takeLatest(authActionTypes.GET_MENU, SAGA.getMenuSaga);
  yield takeLatest(authActionTypes.EDIT_ROLE, SAGA.editRoleSaga);
  yield takeLatest(authActionTypes.GET_ACTION, SAGA.getActionSaga);
  yield takeLatest(authActionTypes.CLONE_PLAN, SAGA.clonePlanSaga);
  yield takeLatest(authActionTypes.ADD_TENANT, SAGA.addTenantSaga);
  yield takeLatest(authActionTypes.GET_ORG_POC, SAGA.getOrgPOCSaga);
  yield takeLatest(authActionTypes.ADD_ORG_POC, SAGA.addOrgPOCSaga);
  yield takeLatest(authActionTypes.DELETE_ROLE, SAGA.deleteRoleSaga);
  yield takeLatest(authActionTypes.EDIT_TENANT, SAGA.editTenantSaga);
  yield takeLatest(authActionTypes.ADD_ORGANIZATION, SAGA.addOrgSaga);
  yield takeLatest(authActionTypes.RESTORE_PLAN, SAGA.restorePlanSaga);
  yield takeLatest(authActionTypes.ADD_CONTRACT, SAGA.addContractSaga);
  yield takeLatest(authActionTypes.GET_ORG_ADMINS, SAGA.OrgAdminsSaga);
  yield takeLatest(authActionTypes.GET_ALL_PLANS, SAGA.getAllPlansSaga);
  yield takeLatest(authActionTypes.ADD_ORG_ADMIN, SAGA.addOrgAdminSaga);
  yield takeLatest(authActionTypes.Get_ROLE_ORGS, SAGA.getRoleOrgsSaga);
  yield takeLatest(authActionTypes.GET_ALL_ROLES, SAGA.getAllRolesSaga);
  yield takeEvery(authActionTypes.GET_ORGANIZATION, SAGA.getAllOrgSaga);
  yield takeLatest(authActionTypes.EDIT_ORGANIZATION, SAGA.editOrgSaga);
  yield takeLatest(authActionTypes.GET_ROLE_BY_ID, SAGA.getRoleByIdSaga);
  yield takeLatest(authActionTypes.TURNBACK_PLAN, SAGA.turnBackPlanSaga);
  yield takeLatest(authActionTypes.EDIT_CONTRACT, SAGA.editContractSaga);
  yield takeLatest(authActionTypes.DELETE_TENANT, SAGA.deleteTenantSaga);
  yield takeLatest(authActionTypes.GET_ALL_TENANTS, SAGA.getTenantsSaga);
  yield takeLatest(authActionTypes.GET_ROLE_FLAG, SAGA.getRoleFlagsSaga);
  yield takeLatest(authActionTypes.UPDATE_ORG_POC, SAGA.updateOrgPOCSaga);
  yield takeLatest(authActionTypes.REMOVE_ORG_POC, SAGA.removeOrgPOCSaga);
  yield takeLatest(authActionTypes.GET_USER_TOKEN, SAGA.getUserTokenSaga);
  yield takeLatest(authActionTypes.DOWNLOAD_USAGE, SAGA.downloadUsageSaga);
  yield takeLatest(authActionTypes.GET_ORG_LIST_ID, SAGA.getOrgsListIdSaga);
  yield takeLatest(authActionTypes.SET_PLAN_STATUS, SAGA.setPlanStatusSaga);
  yield takeLatest(authActionTypes.GET_TENANT_USER, SAGA.getTenantUserSaga);
  yield takeLatest(authActionTypes.DELETE_CONTRACT, SAGA.deleteContractSaga);
  yield takeLatest(authActionTypes.GET_USER_BY_ID, SAGA.getUserOfTenantSaga);
  yield takeLatest(authActionTypes.GET_TENANT_BY_ID, SAGA.getTenantByIdSaga);
  yield takeLatest(authActionTypes.REMOVE_REMINDER, SAGA.removeReminderSaga);
  yield takeLatest(
    authActionTypes.REMOVE_ORG_ACCESS_BY_CONTRACT_END,
    SAGA.removeOrganizationAccessByContractEndSaga
  );
  yield takeLatest(authActionTypes.SET_CUSTOM_SMS_LIST, SAGA.SetCustomSmsSaga);
  yield takeLatest(authActionTypes.GET_PLAN_LOGS_SUPERADMIN, SAGA.getLogsSaga);
  yield takeLatest(authActionTypes.GET_ORG_ROLE_FLAG, SAGA.getOrgRoleFlagsSaga);
  yield takeLatest(authActionTypes.GET_ALL_CONTRACTS, SAGA.getAllContractsSaga);
  yield takeLatest(authActionTypes.GET_ACCOUNT_USAGE, SAGA.getAccountUsageSaga);
  yield takeLatest(authActionTypes.GET_CUSTOM_SMS_LIST, SAGA.CustomSmsListSaga);
  yield takeLatest(authActionTypes.GET_ORGANIZATION_BY_ID, SAGA.getOrgByIdSaga);
  yield takeLatest(authActionTypes.MANUAL_CVRP_LAUNCH_MODE, SAGA.ManuallyCVRPSaga);
  yield takeLatest(
    authActionTypes.CREATE_APP_VERSION,
    SAGA.createAppVersionSaga
  );
  yield takeLatest(
    authActionTypes.UPDATE_TENANT_USER,
    SAGA.updateTenantUserSaga
  );
  yield takeLatest(
    authActionTypes.CREATE_TENANT_USER,
    SAGA.createTenantUserSaga
  );
  yield takeLatest(authActionTypes.CREATE_ORG_USER, SAGA.createOrgUserSaga);
  yield takeLatest(
    authActionTypes.SET_WEBHOOK_CONFIG,
    SAGA.setWebhookConfigSaga
  );
  yield takeLatest(
    authActionTypes.GET_MISSION_REASON,
    SAGA.getMissionReasonSaga
  );
  yield takeLatest(
    authActionTypes.ADD_MISSION_REASON,
    SAGA.addMissionReasonSaga
  );
  yield takeLatest(
    authActionTypes.GET_WEBHOOK_CONFIG,
    SAGA.getWebhookConfigSaga
  );
  yield takeLatest(
    authActionTypes.DOWNLOAD_EXCEL_FILE,
    SAGA.downloadExcelFileSaga
  );
  yield takeLatest(
    authActionTypes.CHANGE_ORG_PASSWORD,
    SAGA.changeOrgPassowrdSaga
  );
  yield takeLatest(
    authActionTypes.UPDATE_ORGANIZATION_USER,
    SAGA.updateOrgUserSaga
  );
  yield takeLatest(
    authActionTypes.GET_ALL_TENANT_USERS,
    SAGA.getAllTenantUsersSaga
  );
  yield takeLatest(authActionTypes.GET_ALL_ORG_USERS, SAGA.getAllOrgUsersSaga);
  yield takeLatest(
    authActionTypes.CHANGE_USER_PASSWORD,
    SAGA.changeUserPasswordSaga
  );
  yield takeLatest(
    authActionTypes.GET_ORGANIZATION_USER,
    SAGA.getOrganizationUserSaga
  );
  yield takeLatest(
    authActionTypes.DELETE_MISSION_REASON,
    SAGA.deleteMissionReasonSaga
  );
  yield takeLatest(
    authActionTypes.UPDATE_MISSION_REASON,
    SAGA.updateMissionReasonSaga
  );
  yield takeLatest(
    authActionTypes.CHANGE_TENANT_PASSWORD,
    SAGA.changeTenantPassowrdSaga
  );
  yield takeLatest(
    authActionTypes.CHANGE_USER_ACTIVATION,
    SAGA.changeUserActivationSaga
  );
  yield takeLatest(
    authActionTypes.GET_ORGANIZATION_USAGE,
    SAGA.getOrganizationUsageSaga
  );
  yield takeLatest(
    authActionTypes.GET_ORGANIZATIONS_USAGE,
    SAGA.getOrganizationsUsageSaga
  );
  yield takeLatest(
    authActionTypes.CHANGE_TENANT_ACTIVATION,
    SAGA.changeTenantActivationSaga
  );
  yield takeLatest(
    authActionTypes.GET_USER_TOKEN_BY_TENANT_ID,
    SAGA.getUserTokenByTenantIdSaga
  );
  yield takeLatest(
    authActionTypes.CHANGE_ORGANIZATION_ACTIVATION,
    SAGA.changeOrgActivationSaga
  );
  yield takeLatest(
    authActionTypes.SET_VERIFICATION_CODE_CONFIG,
    SAGA.setVerificationCodeConfigSaga
  );
  yield takeLatest(
    authActionTypes.GET_VERIFICATION_CODE_CONFIG,
    SAGA.getVerificationCodeConfigSaga
  );
  yield takeLatest(
    authActionTypes.SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE,
    SAGA.downloadOptimizeFileSaga
  );
  yield takeLatest(
    authActionTypes.GET_PLAN_FLOW_PROCESS,
    SAGA.getPlanFlowProcess
  );
  yield takeLatest(
    authActionTypes.GET_RABBIT_MQ_HEALTH,
    SAGA.getRabbitMqHealthSaga
  );
}
